<template>
    <v-container>
        <!-- <div class="text-lg-right">
            <v-btn color="primary" text @click="cancel">close</v-btn>
        </div> -->
        <!-- <v-card-title>
            <span class="headline">Uploading a File For a Partner</span>
        </v-card-title> -->
        <!-- <v-row no-gutters>
            <v-col cols="7"></v-col>
            <v-col cols="5">
                <div class="label_medium d-flex align-center justify-end">
                    <v-select
                        v-model="deliverableType"
                        :items="deliverable_types"
                        label="Please choose a deliverable type"
                        class="flex-grow-1 required_rule"
                        dense
                        outlined
                        :hint="fileTypeHint"
                        persistent-hint
                        :rules="[rules.required]"
                        required
                        @change="handleDeliverableTypeChange">
                    </v-select>
                </div>
                <div class="d-flex d-block justify-end">
                    <div class="d-inline mt-n2 mr-1 grey--text">Generate Email:</div>
                    <v-checkbox
                        v-model="generateEmail"
                        hide-details
                        color="primary"
                        class="d-inline ma-0 pa-0 mt-n2 mr-n2">
                    </v-checkbox>
                </div>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="12" class="px-1">
                <v-file-input
                    v-model="files"
                    :label="labelText"
                    :hint="hintText"
                    persistent-hint
                    truncate-length="300"
                    :multiple="isMultiple"
                    :accept="allowedFileTypes.join(',')"
                    @change="handleChange"
                />
            </v-col>
        </v-row>
         <v-row>
            <v-col cols="12" class="px-1">
                <v-progress-linear v-if="isUploading"
                    :indeterminate="true"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="px-1">
                <div class="pa-4" style="border: 1px solid var(--v-accent-darken1); border-radius: 8px; background-color: #FFF8E1;">
                    <div class="d-flex d-block align-baseline py-1">
                        <v-icon 
                            class="error--text text--darken-1 d-inline mr-3">
                            mdi-alert
                        </v-icon>
                        <div class="d-inline font-weight-bold">STOP — Review Before You Upload!</div>
                        <v-icon 
                            class="error--text text--darken-1 d-inline ml-3">
                            mdi-alert
                        </v-icon>
                    </div>
                    
                    <div class="d-flex d-block align-center py-1 mb-3 caption">Before submitting any documents for client access, please confirm the following to avoid errors or client confusion:</div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-checkbox-marked
                        </v-icon>
                        <div class="d-inline caption">You're uploading the correct document — verify the file name and contents.</div>
                    </div>
                    
                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-checkbox-marked
                        </v-icon>
                        <div class="d-inline caption">You're uploading the most recent version — double-check for outdated drafts.</div>
                    </div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-checkbox-marked
                        </v-icon>
                        <div class="d-inline caption">You're uploading to the right client and folder — confirm the correct recipient and destination.</div>
                    </div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-close-octagon
                        </v-icon>
                        <div class="d-inline caption">Do NOT upload “Internal Only” documents — these should never be shared with clients.</div>
                    </div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-close-octagon
                        </v-icon>
                        <div class="d-inline caption">Do NOT upload resources, templates, or marketing materials here — those belong in the “Resources” section.</div>
                    </div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-eye-check
                        </v-icon>
                        <div class="d-inline caption">Review formatting and professionalism — the document should reflect SRG's quality standards.</div>
                    </div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-lock
                        </v-icon>
                        <div class="d-inline caption">Ensure no confidential or unrelated information is included by mistake.</div>
                    </div>

                    <div class="d-flex d-block align-center pt-1 ml-3">
                        <v-icon 
                            class="primary--text d-inline mr-2">
                            mdi-puzzle
                        </v-icon>
                        <div class="d-inline caption">Cross-check attachments and links — make sure all references or embedded files work correctly.</div>
                    </div>

                    <div class="d-flex d-block align-center mt-5">
                        <v-icon  
                            class="error--text text--darken-1 d-inline mr-2">
                            mdi-lightbulb
                        </v-icon>
                        <div class="d-inline">Take a moment to slow down and review — once uploaded, these documents will be visible to the client.</div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-divider></v-divider> -->
        <v-row>
            <v-col cols="12" class="px-1 d-flex justify-space-between align-center">
                <v-checkbox
                    v-if="(disable_upload && files.length) || (!disable_upload && files.length)"    
                    class="d-inline justify-start mt-n2"
                    color="primary lighten-1 info--text" 
                    hide-details
                    @click="disable_upload = false"
                    label="I've reviewed the documents and understand it will be visible to the client.">
                </v-checkbox>
                <div v-else class="d-inline flex-grow-1"></div>

                <!-- <v-btn 
                    class="d-inline justify-end"
                    color="accent darken-1" 
                    outlined 
                    @click="cancel">
                    Cancel
                </v-btn> -->

                <v-btn
                    class="d-inline justify-end"
                    color="primary lighten-2 info--text"
                    :disabled="disable_upload || isUploading"
                    @click="upload">
                    {{ files.length > 1 ? 'Upload Files' : 'Upload File' }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
    import { safeParseJson } from '../helpers/safe-json';

    export default {
        name: 'UploadPartnerFiles',
        
        props: {
            projectData: Object,
            moduleKey: String,
            projectId: String,
            userId: String,
            isDeliverable: Boolean,
            isIndependent: Boolean,
            triggerUserFeedback: Function,
            closePartnerUploads: Function,
            refreshDocs: Function,
            extraMsg: String
        },
        
        data: () => ({
            files: [],
            message: '',
            current_files: [],
            isUploading: false,
            disable_upload: true,
            warning_fileType: false,
            warning_fileSize: false,
            warning_fileDuplicate: false,
            invalid_filetype_details: [],
            file_match: [],
            warning_message: 'There seems to be an issue with the file being uploaded!',
            allowedFileTypes: [
                "application/octet-stream", // general
                "application/msword", // doc
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
                "application/vnd.ms-word.document.macroenabled.12", // docm on Mac
                "application/vnd.ms-word.document.macroEnabled.12", // docm on Windows
                "application/vnd.ms-excel", // xls
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
                "application/vnd.ms-excel.sheet.macroenabled.12", // xlsm on Mac
                "application/vnd.ms-excel.sheet.macroEnabled.12", // xlsm on Windows
                "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
                "application/pdf", // pdf
                "image/jpeg", // jpg
                "image/png", // png
            ],
            // deliverableType: null,
            changedDeliverableType: false,
            fileTypeHint: '',
            rules: {
                required: value => !!value || 'required'
            },
            generateEmail: false,
            revisionDocCount: 2, // This will be set by the parent component
        }),

        computed: {
            isMultiple () {
                return this.revisionDocCount > 1 ? true : false
            },
            
            hintText () {
                return this.revisionDocCount > 1 ? 'You can upload multiple files at once ... Accepted file types: pdf, doc/docx/docm, xls/xlsx/xlsm' : 'Upload only one file ... Accepted file types: pdf, doc/docx/docm, xls/xlsx/xlsm'
            },
            
            labelText () {
                return this.revisionDocCount > 1 ? 'Click to Select Files' : 'Click to Select a File'
            },

            // deliverable_types () {
            //     if ( this.moduleKey === 'entity-maintenance-program'){
            //         return this.emp_deliverable_types;
            //     }
            //     return this.standard_deliverable_types;
            // }

        },

        methods: {
            fileCheck: async function (fieldData, projectId) {
                try {                    
                    const file_check = await axios.post(`${appUrls.api}/api/file_check`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        fieldData, 
                        projectId
                    })
                    
                    this.current_files = file_check.data.outcome ? safeParseJson(file_check.data.file_obj, []) : []                    
                } catch (err) {
                    console.log(err)
                    return err
                }
            },

            handleChange: function (files) {
                // console.log(files)
                // if ( !this.deliverableType ) return this.fileTypeHint = 'Please select the type of file being uploaded!'

                if (files) {
                    // console.log(files)
                    this.warning_message = 'There seems to be an issue with the file being uploaded!'
                    this.invalid_filetype_details = []
                    this.file_match = []

                    const invalid_file = files.some( file => {
                        return !this.allowedFileTypes.includes(file.type) || file.size == 0 || this.current_files.some( current => current.filename == file.name )
                    })

                    if ( !invalid_file ) {
                        // Save a reference to the file blob.
                        // We will use this later for uploading.
                        this.disable_upload = true
                        this.warning_fileType = false
                        this.warning_fileDuplicate = false
                        this.files = files
                    } else {
                        this.disable_upload = true

                        files.forEach( file => {
                            if ( !this.allowedFileTypes.includes(file.type) ) {
                                this.warning_fileType = true
                                this.invalid_filetype_details.push(file)
                            }
                            
                            if ( file.size == 0 ) {
                                this.warning_fileSize = true
                            }

                            if ( this.current_files.some( current => current.filename == file.name ) ) {
                                this.current_files.forEach( current => {
                                    if ( current.filename == file.name ) {
                                        this.file_match.push(current.filename)
                                    }
                                })
                                this.warning_fileDuplicate = true
                            }
                        })
                        
                        if ( this.invalid_filetype_details.length ) { 
                            this.warning_message = `The file type <strong>${this.invalid_filetype_details[0].type}</strong> is not permitted for uploading! Allowed file types include: pdf, doc/docx/docm, xls/xlsx/xlsm`
                        }
                            
                        if ( this.warning_fileSize ) {
                            this.warning_message = `The file size is 0mb, please check the file and upload a file with a larger size.`
                        }

                        if ( this.warning_fileDuplicate ) {
                            if ( this.file_match.length == 1 ) {
                                this.warning_message = `This file: <strong>${this.file_match}</strong> seems to be a duplicate, please delete the file before uploading the new one.`
                            } else {
                                this.warning_message = `These files: <strong>${this.file_match.join(', ')}</strong> seem to be a duplicates, please delete these files before uploading the new ones.`
                            }
                        }
                        
                        this.files = []
                    }

                    // console.log(this.files)
                }
            },
            // handleChange: function (file) {
            //     if (file) {
            //         // Save a reference to the file blob.
            //         // We will use this later for uploading.
            //         this.file = file;
            //     }
            // },
            upload: async function () {
                // ONE REQUEST AT A TIME - A DOUBLE-CLICK USED TO UPLOAD (AND EMAIL) THE SAME FILE TWICE
                if ( this.isUploading ) return

                // if ( !this.deliverableType ) return this.fileTypeHint = 'Please select the type of deliverable being uploaded!'

                this.isUploading = true;
                
                const formData = new FormData(); // document.getElementById('form')
                this.files.forEach( file => {
                    // console.log(file)
                    return formData.append('files', file);
                })
                formData.append('authentication', Cookie.get('token'));
                formData.append('moduleKey', this.moduleKey);
                formData.append('userId', this.userId);
                formData.append('projectId', this.projectId);
                formData.append('isIndependent', this.isIndependent);
                formData.append('isDeliverable', this.isDeliverable);
                // formData.append('deliverableType', this.deliverableType);
                formData.append('isPartner', 'true');
                formData.append('generateEmail', this.generateEmail);
                formData.append('source', 'admin');
                // console.log(...formData)

                try {
                    const res = await axios.post(`${appUrls.api}/api/upload_file`, formData)
                    
                    if ( res.data.outcome === false ) {
                        throw new Error(res.data.message);
                    }

                    this.$emit('closePartnerUploads');
                    this.isUploading = false;
                    this.file = null;
                    this.$emit('triggerUserFeedback', true, 'File(s) successfully uploaded!' );

                    setTimeout(() => { 
                        this.$emit('refreshDocs', this.projectData);
                        // this.deliverableType = ''
                        // this.changedDeliverableType = false
                        this.files=[]
                    }, 1500)

                } catch (err) {
                    setTimeout(() => {
                        this.$emit('closePartnerUploads');
                        // this.deliverableType = ''
                        // this.changedDeliverableType = false
                        this.isUploading = false;
                        this.file = null;
                        this.$emit('triggerUserFeedback', true, err.message, 'accent' );
                    }, 2000)
                }
            },

            cancel: function () {
                // Reset the control on cancel so it loads fresh next time
                // this.deliverableType = ''
                // this.changedDeliverableType = false
                this.isUploading = false;
                this.files = null;

                this.$emit('closePartnerUploads');
            }
        }
    }
</script>

<style scoped>
    .required_rule >>> .v-messages__message {
        color:red;
    }
</style>


// WEBPACK FOOTER //
// src/components/UploadPartnerFiles.vue